import { InputText } from 'primereact/inputtext';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FieldErrorMessage } from '@features/campaigns/builder/components/FormFields/common/FieldErrorMessage/FieldErrorMessage.tsx';
import { FormFields } from '@features/users/adminPanel/components/FormFields/FieldTypes.ts';
import { FieldWrapper } from '@features/users/adminPanel/components/FormFields/FieldWrapper.tsx';
import { i18nNameSpace } from '@shared/consts/i18n.ts';

import styles from './FieldVatNumber.module.scss';

interface FieldVatNumberProps {
  maxLength: number;
}

export function FieldVatNumber({ maxLength }: FieldVatNumberProps) {
  const { t } = useTranslation(i18nNameSpace.USERS);
  const { control } = useFormContext();

  return (
    <FieldWrapper labelText={t('page.adminPanel.formFields.vatNumber.label')} fieldType={FormFields.VAT_NUMBER}>
      <Controller
        control={control}
        name={FormFields.VAT_NUMBER}
        render={({ field, formState: { errors } }) => {
          return (
            <>
              <InputText
                {...field}
                type='text'
                id={FormFields.VAT_NUMBER}
                className={styles.input}
                placeholder={t('page.adminPanel.formFields.vatNumber.placeholder')}
                maxLength={maxLength}
              />
              {errors?.[FormFields.VAT_NUMBER] && (
                <FieldErrorMessage fieldErrorData={errors} fieldName={FormFields.VAT_NUMBER} />
              )}
            </>
          );
        }}
      />
    </FieldWrapper>
  );
}
